import { render } from "./B2bPageAuditorias.vue?vue&type=template&id=3086087e&scoped=true&lang=pug"
import script from "./B2bPageAuditorias.vue?vue&type=script&lang=js"
export * from "./B2bPageAuditorias.vue?vue&type=script&lang=js"

import "./B2bPageAuditorias.vue?vue&type=style&index=0&id=3086087e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3086087e"]])

export default __exports__